/**
 * Stat Table Columns
 *
 * Shared column sets for the canonical stat-window shape the backend
 * returns (playerAnalyserService.js's NBA and NFL stat-window builders —
 * fantasyPts, points, rebounds, ... for NBA; fantasyPtsPerGame, passYards,
 * ... for NFL). StatTable caps at 5 columns, so this is "the 5 that matter
 * for the league's format" (Player Analyser, Stage 3) — everything else the
 * window carries is still in the raw data for the ask bar to answer about.
 *
 * NFL's FPTS column reads `fantasyPtsPerGame`, NOT `fantasyPts` — the two
 * sports used to share the bare `fantasyPts` key here despite NBA's being a
 * per-game average and NFL's being a season total, so the identical "FPTS"
 * header rendered a season total (e.g. "247.0") through the exact same cell
 * a per-game NBA number renders through. NFL's window no longer carries a
 * bare `fantasyPts` at all (see playerAnalyserService.js's buildNflStatWindow)
 * — don't reintroduce it here.
 *
 * Used by PlayerAnalyser.jsx and TeamAnalyser.jsx's top performers — one
 * definition, not two, so the two pages can't quietly drift onto different
 * "key numbers" for the same underlying stat shape.
 */

export const NBA_STAT_COLUMNS = [
  { key: 'fantasyPts', label: 'FPTS' }, { key: 'points', label: 'PTS' }, { key: 'rebounds', label: 'REB' },
  { key: 'assists', label: 'AST' }, { key: 'steals', label: 'STL' },
]

// QB production doesn't overlap with skill-position production at all, so a
// single fixed NFL column set would show a wall of zeros for one side or the
// other — this is the one position-aware branch, everything else stays generic.
export const NFL_QB_STAT_COLUMNS = [
  { key: 'fantasyPtsPerGame', label: 'FPTS/GM' }, { key: 'passYards', label: 'PASS YDS' }, { key: 'passTD', label: 'PASS TD' },
  { key: 'interceptions', label: 'INT' }, { key: 'rushYards', label: 'RUSH YDS' },
]
export const NFL_SKILL_STAT_COLUMNS = [
  { key: 'fantasyPtsPerGame', label: 'FPTS/GM' }, { key: 'rushYards', label: 'RUSH YDS' }, { key: 'rushTD', label: 'RUSH TD' },
  { key: 'receptions', label: 'REC' }, { key: 'recYards', label: 'REC YDS' },
]

/** Pick the right column set for a player's sport + position. */
export function statColumnsFor(sport, position) {
  if (sport === 'nfl') return position === 'QB' ? NFL_QB_STAT_COLUMNS : NFL_SKILL_STAT_COLUMNS
  return NBA_STAT_COLUMNS
}
